var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "sweet-modal",
        {
          ref: "modal",
          attrs: {
            width: _vm.$mq.desktop ? "500" : "100%",
            "overlay-theme": "dark",
            blocking: ""
          }
        },
        [
          _vm.step === 1
            ? _c("section", { staticClass: "step-one" }, [
                _c("div", { staticClass: "text-center pb-3" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/ic-phone-verification.svg",
                      alt: "",
                      width: "80"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("message.verification.confirm_phone_number_title")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "message.verification.confirm_phone_number_detail"
                          )
                        ) +
                        "\n        "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-4" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-8 offset-md-2 text-center" },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.verification.country")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "select-jumbo" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedCountryCode,
                                expression: "selectedCountryCode"
                              }
                            ],
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedCountryCode = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.allCountries, function(country) {
                            return _c(
                              "option",
                              { domProps: { value: country.code } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(country.name) +
                                    "\n              "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "mt-3" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.verification.phone_number"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group mb-3" }, [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c(
                            "span",
                            {
                              staticClass: "input-group-text",
                              attrs: { id: "basic-addon1" }
                            },
                            [
                              _vm._v(
                                "+" +
                                  _vm._s(
                                    _vm.allCountries[_vm.selectedCountryCode]
                                      .dialCode
                                  )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.phoneNumber,
                              expression: "phoneNumber"
                            }
                          ],
                          staticClass: "form-control input-jumbo",
                          attrs: {
                            type: "tel",
                            placeholder:
                              _vm.allCountries[_vm.selectedCountryCode]
                                .phoneFormat
                          },
                          domProps: { value: _vm.phoneNumber },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.phoneNumber = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.invalidPhone
                        ? _c(
                            "div",
                            { staticClass: "-status-alert text-remark mt-3" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.verification.invalid_phone_number"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errorRegisteredPhoneNumber
                        ? _c(
                            "div",
                            { staticClass: "-status-alert text-remark mt-3" },
                            [
                              _c("i", {
                                staticClass: "fas fa-exclamation-triangle"
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.verification.registered_phone_number"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-4" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "button button-large button-block -cyan",
                            on: { click: _vm.validatePhoneNumber }
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.verification.confirm_phone_number"
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ])
            : _vm.step === 2
            ? _c("section", { staticClass: "step-two" }, [
                _c("div", { staticClass: "text-center pb-3" }, [
                  _c("img", {
                    attrs: {
                      src: "/static/img/ic-phone-verification.svg",
                      alt: "",
                      width: "80"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("h3", [
                  _vm._v(
                    _vm._s(_vm.$t("message.verification.enter_six_digits"))
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-8 offset-md-2" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.verification.we_sent_sms_to")) +
                        "\n          " +
                        _vm._s(_vm.formattedPhoneNumber) +
                        "\n          " +
                        _vm._s(
                          _vm.$t("message.verification.please_fill_in_code")
                        ) +
                        "\n        "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row py-3" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("v-otp-input", {
                        ref: "otpInput",
                        staticClass:
                          "justify-content-center align-items-center",
                        attrs: {
                          "input-classes": "otp-input",
                          separator: "",
                          "num-inputs": 6,
                          "should-auto-focus": true,
                          "is-input-num": true
                        },
                        on: { "on-complete": _vm.handleOnComplete }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 text-center" }, [
                    _vm.invalidCode
                      ? _c(
                          "div",
                          { staticClass: "-status-alert text-remark mt-3" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.errorMessages[_vm.errorIndex]) +
                                "\n          "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isVerifying
                      ? _c("div", { staticClass: "mt-3" }, [
                          _c("img", {
                            attrs: { src: "/static/img/ring.gif", width: "60" }
                          })
                        ])
                      : _c("div", { staticClass: "mt-3" }, [
                          _c("div", { staticClass: "my-3" }, [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-outline-secondary",
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.changePhoneNumber.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.verification.change_phone_number"
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "my-3" }, [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-outline-info",
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.sendVerificationCode.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fal fa-redo" }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("message.verification.resend_code")
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ])
                        ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [_c("hr")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 text-center" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.verification.verification_otp_alert")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-outline-info",
                        attrs: {
                          href: "https://line.me/R/ti/p/@BeNeat",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("message.subscription.contact_admin"))
                        )
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "sweet-modal",
        {
          ref: "verifiedModal",
          attrs: { "overlay-theme": "dark", icon: "success" }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("message.verification.your_phone_number_is_verified")
              ) +
              "\n    "
          ),
          _c("div", { staticClass: "pt-4" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-info btn-block",
                on: {
                  click: function($event) {
                    return _vm.closeVerifiedModal()
                  }
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.button.close")) +
                    "\n      "
                )
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31500856", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31500856","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/PhoneVerificationModal.vue
// module id = 1464
// module chunks = 0